module.exports = __webpack_public_path__ + "img/blueits_small.db9f1f9c.png";